import {z} from 'zod';

/*
{
    "defaultLanguage": "pl",
    "fallbackLng": {
        "pl36": [
          "pl"
        ],
        "pl": [
            "en"
        ],
        "en": [
            "pl"
        ],
        "es": [
            "en",
            "pl"
        ],
        "default": [
            "en",
            "pl"
        ]
    },
    "weblateProject": "automapa-web",
    "languagesAvailableForUser": {
        "pl": "polski",
        "pl36": "polski (zlecenia odbioru)",
        "en": "english"
    },
    "availableComponents": {
        "lastmile": "lastmile.json"
    }
}
 */

export const LangSettingsSchema = z.object({
    defaultLanguage: z.string(),
    fallbackLng: z.record(z.array(z.string())),
    weblateProject: z.string(),
    languagesAvailableForUser: z.record(z.string()).nullable().catch(null),
    availableComponents: z.record(z.string())
});
export type LangSettingsType = z.infer<typeof LangSettingsSchema>;